<template>
  <div>
    <h1>Preferentes</h1>
    <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Buscar"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Registros por página" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions" class="form-control"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      show-empty
      stacked="md"
      :items="getAllPreferentialPassengers"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      empty-text="No existen registros por mostrar"
      emptyFilteredText="No existen registros por mostrar"
    >
    <template v-slot:cell(phoneNumber)='row'>
      {{ row.item.phoneNumber.replace('+52', '') }}
    </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <div class="text-center" v-if="$apollo.queries.getAllPreferentialPassengers.loading">
        <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
export default {
  data() {
    return {
      getAllPreferentialPassengers: [],
      fields: [
        { key: 'name', label: 'Nombre(s)' },
        { key: 'lastName', label: 'Apellidos' },
        { key: 'email', label: 'Correo electrónico' },
        { key: 'phoneNumber', label: 'Número de teléfono' },
        { key: 'licenseExpirationDate', label: 'Vigencia' },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      filter: null,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
    }
  },
  apollo: {
    getAllPreferentialPassengers: {
      query: gql`query getAllPreferentialPassengers{
          getAllPreferentialPassengers{
            id
           active
           createdAt
           email
           lastName
           name
           phoneNumber
           cognitoUsername
           profilePicture
           updatedAt
           numberLicense
           licenseExpirationDate
          }
        }
         `,
      context: headers(),
      error (erro) {
        console.log(erro)
      },
      result ({ data, loading, networkStatus }) {
        console.log(data.getAllPreferentialPassengers)

        this.totalRows = data.getAllPreferentialPassengers.length
      },
    },
  },
  methods: {
    onFiltered(filtered) {
      this.totalRows = filtered.length
      this.currentPage = 1
    },
  },
}
</script>

<style>

</style>
